export function isNull(text, valueWhenNull = '', expireDate) {
    return (text === null || text === undefined) ? valueWhenNull : text;
}

export function urlSearchParams_GET() {
    const url = window.location.href;
    const searchParams = new URLSearchParams(new URL(url).search);
    const result = {};

    for (const [key, value] of searchParams.entries()) {
      result[key] = value;
    }

    return result;
}

export function replaceAll(str, toFind, ReplaceWith) {
    return str.split(toFind).join(ReplaceWith);
}

export function replaceParams(str, params) {
    //str: string, params: json object of params.
    //example: replaceParams('__@p1__', {'p1': 123})    //results: __123__
    let result = str;

    if (!params) {
        return result;
    }

    (Object.keys(params)).forEach(p => { result = replaceAll(result, `@${p}`, params[p]) })

    return result;
}

export function dateAddDays(myDate, days) {
    if (!myDate) {
        return myDate;
    }

    const result = new Date(myDate);
    result.setDate(result.getDate() + days);

    return result;
}

export function dateObject_to_dateString(myDate) {
    if (!myDate) {
        return undefined;
    }

    return `${myDate.getFullYear()}-${('00' + (myDate.getMonth() + 1).toString()).slice(-2)}-${('00' + myDate.getDate().toString()).slice(-2)}`
}

export function JSON_getDbDateValue(JSON_formatted_datetime) {
    //Explanation: see JSON_getDateTime function in database
    return (JSON_formatted_datetime) ? JSON_formatted_datetime : '1999-12-31T00:00:00.000+00:00';
}

export function fileName_removeInvalidChars(fileName) {
    return fileName.replace(/[/\\?%*:|"<>]/g, '_');
}

export function downloadBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName_removeInvalidChars(fileName);
    a.click();
    a.remove();
}

export function deepCopy(O) {
    if (O === undefined) {
        return undefined;
    }
    return JSON.parse(JSON.stringify(O));
}

export function getDateOnly(dateObject) {
    if (!dateObject) {
        return undefined;
    }

    return new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate());
    //return new Date(`${dateObject.getFullYear}-${dateObject.getMonth() + 1}-${dateObject.getDate()}`);
}

export function roundToDate(dateObject) {
    if (!dateObject) {
        return undefined;
    }

    let result = getDateOnly(dateObject);

    if (dateObject.getHours() >= 12) {
        result = dateAddDays(result, 1);
    }

    return result;
}

export function color_get_invert(hexString) {
    let hex = parseInt(hexString.substring(1), 16);
    let r = hex >> 16;
    hex -= r << 16;
    let g = hex >> 8;
    hex -= g << 8;
    let b = hex;
    const hex_r = ('00' + Number(255 - r).toString(16).toUpperCase()).slice(-2);
    const hex_g = ('00' + Number(255 - g).toString(16).toUpperCase()).slice(-2);
    const hex_b = ('00' + Number(255 - b).toString(16).toUpperCase()).slice(-2);

    //return `rgb(${255-r},${255-g},${255-b})`;
    return '#' + hex_r + hex_g + hex_b;
}

export function color_get_invert_fix(hexString, darkColor, lightColor) {
    const r = parseInt(hexString.substr(1, 2), 16);
    const g = parseInt(hexString.substr(3, 2), 16);
    const b = parseInt(hexString.substr(5, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return (yiq >= 160) ? darkColor : lightColor;
}

export function JSON_getTag(jsonValue, arrayOfStructure) {
    if (typeof jsonValue !== 'object' || !Array.isArray(arrayOfStructure)) {
        return undefined;
    }

    if (arrayOfStructure.length < 1) {
        return undefined;
    }

    let temp = deepCopy(jsonValue);

    for (let i = 0; i < arrayOfStructure.length; i++) {
        const currentTag = arrayOfStructure[i];
        if (!currentTag) {
            return undefined;
        }

        temp = temp[currentTag];

        if (temp === undefined) {
            return undefined;
        }
    }

    return temp;
}

export function JSON_setTag(jsonValue, arrayOfStructure, newTagValue) {
    if (typeof jsonValue !== 'object' || !Array.isArray(arrayOfStructure)) {
        return undefined;
    }

    const result = deepCopy(jsonValue);

    if (arrayOfStructure.length < 1) {
        if (typeof newTagValue !== 'object') {
            return undefined;
        }

        return deepCopy(newTagValue);
    }

    let temp = result;

    for (let i = 0; i < arrayOfStructure.length - 1; i++) {
        const currentTag = arrayOfStructure[i];
        if (!currentTag) {
            return undefined;
        }

        if (!temp[currentTag]) {
            temp[currentTag] = {};
        }

        temp = temp[currentTag];
    };

    const lastKey = arrayOfStructure[arrayOfStructure.length - 1]
    if (newTagValue === undefined) {
        delete temp[lastKey];
    } else {
        temp[lastKey] = newTagValue;
    }

    return result;
}
